import React from 'react';
import { Check, X } from 'lucide-react';
export function Comparison() {
  const rows = [{
    aspect: 'Tiempo para ver resultados',
    old: 'Semanas o meses',
    new: '48 horas'
  }, {
    aspect: 'Pasar hambre',
    old: 'Sí, constantemente',
    new: 'No, nunca'
  }, {
    aspect: 'Contar calorías',
    old: 'Sí, obsesivamente',
    new: 'No'
  }, {
    aspect: 'Costo semanal',
    old: "$150-300 en 'superfoods'",
    new: 'Menos de $40 en Walmart'
  }, {
    aspect: 'Ataca la causa raíz',
    old: 'No (solo síntomas)',
    new: 'Sí (inflamación)'
  }, {
    aspect: 'Funciona después de los 40',
    old: 'Raramente',
    new: 'Diseñado para eso'
  }, {
    aspect: 'Energía',
    old: 'La reduce',
    new: 'La multiplica'
  }];
  return <section className="py-20 bg-brand-light" data-id="element-19">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-22">
            El Viejo Camino vs. La Pausa Enzimática
          </h2>
        </div>

        {/* Desktop: tabla */}
        <div className="hidden md:block overflow-x-auto rounded-xl shadow-xl bg-white" data-id="element-23">
          <table className="w-full" data-id="element-24">
            <thead data-id="element-25">
              <tr className="bg-brand-dark text-white" data-id="element-26">
                <th className="py-6 px-6 text-left font-serif text-xl w-1/3" data-id="element-27">
                  Aspecto
                </th>
                <th className="py-6 px-6 text-left font-serif text-xl w-1/3 bg-red-900/20" data-id="element-28">
                  Dietas Tradicionales
                </th>
                <th className="py-6 px-6 text-left font-serif text-xl w-1/3 bg-green-900/20 text-brand-gold" data-id="element-29">
                  Reset Metabólico
                </th>
              </tr>
            </thead>
            <tbody data-id="element-30">
              {rows.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-31">
                  <td className="py-4 px-6 font-bold text-gray-700 border-b border-gray-100" data-id="element-32">
                    {row.aspect}
                  </td>
                  <td className="py-4 px-6 text-gray-600 border-b border-gray-100 bg-red-50/50" data-id="element-33">
                    <div className="flex items-center" data-id="element-34">
                      <X className="h-5 w-5 text-red-500 mr-2 flex-shrink-0" data-id="element-35" />
                      {row.old}
                    </div>
                  </td>
                  <td className="py-4 px-6 text-brand-dark font-bold border-b border-gray-100 bg-green-50/50" data-id="element-36">
                    <div className="flex items-center" data-id="element-37">
                      <Check className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-38" />
                      {row.new}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile: cards apiladas */}
        <div className="md:hidden space-y-3" data-id="element-39">
          {/* Header labels */}
          <div className="grid grid-cols-2 gap-2 px-1" data-id="element-40">
            <div className="bg-red-900/80 text-white text-xs font-bold text-center py-2 rounded-lg" data-id="element-41">
              Dietas Tradicionales
            </div>
            <div className="bg-brand-dark text-brand-gold text-xs font-bold text-center py-2 rounded-lg" data-id="element-42">
              Reset Metabólico
            </div>
          </div>

          {rows.map((row, i) => <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-43">
              <div className="bg-brand-dark/5 px-4 py-2 border-b border-gray-100" data-id="element-44">
                <span className="text-xs font-bold text-brand-dark uppercase tracking-wide" data-id="element-45">
                  {row.aspect}
                </span>
              </div>
              <div className="grid grid-cols-2 divide-x divide-gray-100" data-id="element-46">
                <div className="px-3 py-3 bg-red-50/50 flex items-start gap-2" data-id="element-47">
                  <X className="h-4 w-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-48" />
                  <span className="text-sm text-gray-600" data-id="element-49">{row.old}</span>
                </div>
                <div className="px-3 py-3 bg-green-50/50 flex items-start gap-2" data-id="element-50">
                  <Check className="h-4 w-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-51" />
                  <span className="text-sm text-brand-dark font-bold" data-id="element-52">
                    {row.new}
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}